/**
 * ใช้ ImgBB API สำหรับอัปโหลดสลิป
 */
export async function uploadFile(file) {
  const formData = new FormData();
  formData.append('image', file);

  // API Key ของคุณที่ตั้งค่าไว้
  const API_KEY = '2cf00e3e9d332c0f1de94f6602f8041f'; 

  // แก้ไขเงื่อนไขการเช็ค: ให้เช็คเฉพาะกรณีที่ลืมกรอกรหัส หรือยังเป็นข้อความภาษาไทยเท่านั้น
  if (!API_KEY || API_KEY === 'ใส่_API_KEY_ของคุณที่นี่') {
    throw new Error('กรุณาตั้งค่า API Key ของ ImgBB ในไฟล์ src/lib/uploadService.js ก่อนใช้งาน');
  }

  try {
    const response = await fetch(`https://api.imgbb.com/1/upload?key=${API_KEY}`, {
      method: 'POST',
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      return data.data.url; // คืนค่า URL ของรูปภาพ
    } else {
      // แสดงข้อความ Error จาก ImgBB โดยตรงเพื่อความชัดเจน
      throw new Error(data.error?.message || 'อัปโหลดรูปภาพไม่สำเร็จ');
    }
  } catch (error) {
    console.error('Upload Error Details:', error);
    throw new Error(`ระบบอัปโหลดรูปขัดข้อง: ${error.message}`);
  }
}